import './gallerydesktop.less'

import React from 'react'
import {ImageType, WysiwygType} from 'types'
import {style} from 'util/style'
import {GalleryBackground, GalleryIframe, GalleryQuote} from './gallery'

const styles = style('gallerydesktop', ['top', 'bottom'])

export type GalleryDesktopType = {
	images?: Array<ImageType>
	iframe?: string
	quote1?: WysiwygType
	quote2?: WysiwygType
}

export const GalleryDesktop: React.FC<GalleryDesktopType> = ({
	images,
	iframe,
	quote1,
	quote2
}) => {
	return (
		<div className={styles()}>
			<GalleryDesktopTop images={images} quote1={quote1} />
			<GalleryDesktopBottom images={images} iframe={iframe} quote2={quote2} />
		</div>
	)
}

export const GalleryDesktopTop: React.FC<{
	images?: Array<ImageType>
	quote1?: WysiwygType
}> = ({images, quote1}) => {
	return (
		<div className={styles.top()}>
			<div className={styles.top('left')}>
				<GalleryBackground image={images[0]} />
			</div>
			<div className={styles.top('right')}>
				<div className={styles.top('right-image')}>
					<GalleryBackground image={images[1]} />
				</div>
				{quote1 && (
					<div className={styles.top('right-quote')}>
						<GalleryQuote quote={quote1} />
					</div>
				)}
			</div>
		</div>
	)
}

export const GalleryDesktopBottom: React.FC<{
	images?: Array<ImageType>
	iframe?: string
	quote2?: WysiwygType
}> = ({images, iframe, quote2}) => {
	return (
		<div className={styles.bottom()}>
			<div className={styles.bottom('left')}>
				<div className={styles.bottom('left-iframe')}>
					<GalleryIframe iframe={iframe} />
				</div>
			</div>
			<div className={styles.bottom('center')}>
				{quote2 && (
					<div className={styles.bottom('center-quote')}>
						<GalleryQuote quote={quote2} />
					</div>
				)}
				<div className={styles.bottom('center-image').mod({quote: quote2})}>
					<GalleryBackground image={images[2]} />
				</div>
			</div>
			<div className={styles.bottom('right')}>
				<div className={styles.bottom('right-top')}>
					<div className={styles.bottom('right-top-left')}>
						<GalleryBackground image={images[3]} />
					</div>
					<div className={styles.bottom('right-top-right')}>
						<GalleryBackground image={images[4]} />
					</div>
				</div>
				<div className={styles.bottom('right-bottom')}>
					<GalleryBackground image={images[5]} />
				</div>
			</div>
		</div>
	)
}
